import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './baseComponents'
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyAgL1_2HbKMftc7W2-g32TABC5gsTn57yQ"
    key: ""
  }
});

Vue.config.productionTip = false

import './filters/capitalize'
import './filters/formatDate'
import './filters/formatPrice'

import './directives/v-click-out'

import './assets/less/style.less'

const VueInputMask = require('vue-inputmask').default

Vue.use(VueInputMask)

import vSlideToggle from './plugins/v-slide-toggle'
Vue.use(vSlideToggle)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  offset: -70
})

//V-MODAL
import vModal from './plugins/v-modal'
import TheModals from './components/TheModals'

Vue.use(vModal, {
  router,
  store,
  i18n,
  ModalsList: TheModals
})

const main = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default main
